var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.277478 0.277478C0.647448 -0.0924926 1.24729 -0.0924926 1.61726 0.277478L6 4.66022L10.3827 0.277478C10.7527 -0.0924926 11.3526 -0.0924926 11.7225 0.277478C12.0925 0.647448 12.0925 1.24729 11.7225 1.61726L7.33978 6L11.7225 10.3827C12.0925 10.7527 12.0925 11.3526 11.7225 11.7225C11.3526 12.0925 10.7527 12.0925 10.3827 11.7225L6 7.33978L1.61726 11.7225C1.24729 12.0925 0.647448 12.0925 0.277478 11.7225C-0.0924926 11.3526 -0.0924926 10.7527 0.277478 10.3827L4.66022 6L0.277478 1.61726C-0.0924926 1.24729 -0.0924926 0.647448 0.277478 0.277478Z",
    fill: "#29A340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenClose);
export default __webpack_public_path__ + "static/media/greenClose.4c24be2775bebb8ee471cb43e04fd7b7.svg";
export { ForwardRef as ReactComponent };